{
  "rules": [
    {
      "index": 1,
      "text": "Forbrukslån"
    },
    {
      "index": 2,
      "text": "Rentebærende kredittkortgjeld"
    }
  ]
}
